import React from 'react';
import { HealthPulse } from './HealthPulse';
import { Card, CardContent, CardHeader, CardTitle } from '../Components/ui/card';
import { Activity } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// Interface from HealthPulse.tsx
interface HealthPulseItem {
  area: string;
  score: number;
  initialScore: number;
  priority?: boolean;
}

interface HealthPulseSectionProps {
  data?: {
    healthPulseItems: HealthPulseItem[];
    weeklyInsights: string[];
    improvementSummaries: string[];
    needsAttentionSummaries: string[];
  };
  mostImproved?: string;
  focusArea?: string;
  positiveAreas?: number;
  totalAreas?: number;
  environmentTips?: {
    title: string;
    tips: string[];
  };
}

export const HealthPulseSection: React.FC<HealthPulseSectionProps> = ({
  data = {
    healthPulseItems: [],
    weeklyInsights: [],
    improvementSummaries: [],
    needsAttentionSummaries: []
  },
  mostImproved = "Sleep",
  focusArea = "Emotional Regulation",
}) => {
  const { t } = useTranslation();
  
  return (
    <Card className="shadow-sm hover:shadow-md transition-shadow rounded-xl overflow-hidden">
      <CardHeader className="pb-2 bg-gradient-to-br from-gray-50 to-white">
        <CardTitle className="flex items-center text-xl">
          <Activity className="w-5 h-5 text-blue-500 mr-2" />
          {t('dashboard.healthPulse.title', 'Your Weekly Health Pulse')}
        </CardTitle>
      </CardHeader>
      <CardContent className="p-5">
        <div className="mb-3">
          <p className="text-sm text-gray-600">
            {t('dashboard.healthPulse.description', 'A snapshot of how your habits and health are trending — drawn from your recent conversations.')}
          </p>
        </div>
        
        <HealthPulse 
          data={data.healthPulseItems}
          mostImproved={mostImproved}
          focusArea={focusArea}
          weeklyInsights={data.weeklyInsights}
          improvementSummaries={data.improvementSummaries}
          needsAttentionSummaries={data.needsAttentionSummaries}
        />
      </CardContent>
    </Card>
  );
};

export default HealthPulseSection;
